/**
 *
 * Asynchronously loads the component for PostSessionAssessment
 *
 */

import loadable from '@loadable/component';

export default loadable(() => import('./index'));
